/* import __COLOCATED_TEMPLATE__ from './fullscreen-table.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./fullscreen-table.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());